import React, { useContext } from "react";
import PropTypes from "prop-types";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import { setAttributionCopied } from "core/AssetDownload/Context/actions";

// Google Analytics
import { sendEvent } from "js/utils/google-analytics";

// components
import Button from "core/Button";

// styles
import { CopyControlStyled } from "./styles";

// utils
import { copyToClipboard, getButtonText } from "./utils";

const CopyControl = ({ isDesktop }) => {
    const { state, dispatch } = useContext(AssetDownloadContext);

    const {
        assetType,
        asset,
        attribution: { isCopied },
        assetDownloadConfig,
        purchaseType
    } = state;

    const { getHtmlAttribution, attributionButtonText } = assetDownloadConfig;

    const copyAttributionToClipboard = () => {
        const copyText = getHtmlAttribution(asset, purchaseType);
        copyToClipboard(copyText.string);
        sendEvent(assetType, "copy.attribution", asset.id);
        dispatch(setAttributionCopied(true));
    };

    return (
        <CopyControlStyled isDesktop={isDesktop}>
            <Button
                onClick={copyAttributionToClipboard}
                size="md"
                width="100%"
                darkMode={isDesktop}
            >
                {getButtonText(isCopied, isDesktop, attributionButtonText)}
            </Button>
        </CopyControlStyled>
    );
};

export default CopyControl;

// prop-types
CopyControl.propTypes = {
    isDesktop: PropTypes.bool
};
